import { Canvas, useFrame } from "@react-three/fiber";
import { Environment, useGLTF } from "@react-three/drei";
import { useRef, useEffect, useState } from "react";

const TitleModel = ({ mouse, scale }) => {
  const { scene } = useGLTF("/models/Title.glb");
  const ref = useRef();

  useFrame(() => {
    if (ref.current) {
      ref.current.rotation.y += (mouse.x * 0.5 - ref.current.rotation.y) * 0.1;
      ref.current.rotation.x += (-mouse.y * 0.3 - ref.current.rotation.x) * 0.1;
    }
  });

  return <primitive object={scene} ref={ref} scale={scale} />;
};

const Title3D = ({ className }) => {
  const [mouse, setMouse] = useState({ x: 0, y: 0 });
  const [scale, setScale] = useState([1, 1, 1]);
  const containerRef = useRef();

  useEffect(() => {
    const updateScale = () => {
      const width = window.innerWidth;
      const base = 1440; // référence taille "normale"
      const ratio = Math.min(1, width / base);
      setScale([ratio, ratio, ratio]);
    };

    updateScale(); // initial
    window.addEventListener("resize", updateScale);
    return () => window.removeEventListener("resize", updateScale);
  }, []);

  useEffect(() => {
    const handleMouseMove = (e) => {
      const x = (e.clientX / window.innerWidth - 0.5) * 2;
      const y = (e.clientY / window.innerHeight - 0.5) * 2;
      setMouse({ x, y });
    };

    const handleScroll = () => {
      const vh = window.innerHeight;
      const canvasHeight = vh * 0.6;
      const canvasTop = vh / 2 - canvasHeight / 2;
      const canvasBottom = canvasTop + canvasHeight;

      const visibleBottom = vh;
      const overflow = visibleBottom - canvasBottom;
      const scrollPastCanvasBottom = window.scrollY - overflow;

      const percent = Math.min(Math.max(scrollPastCanvasBottom / canvasHeight, 0), 1);
      const clip = percent * 100;

      if (containerRef.current) {
        containerRef.current.style.clipPath = `inset(0% 0% ${clip}% 0%)`;
        containerRef.current.style.opacity = `${1 - percent}`;
      }
    };

    window.addEventListener("mousemove", handleMouseMove);
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("mousemove", handleMouseMove);
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <div
      ref={containerRef}
      style={{
        position: "fixed",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        width: "100vw",
        height: "100vh",
        zIndex: 10,
        overflow: "hidden",
        clipPath: "inset(0% 0% 0% 0%)",
        pointerEvents: "none",
      }}
    >
      <Canvas
        className={className}
        camera={{ position: [0, 0, 5], fov: 45 }}
        gl={{ alpha: true }}
        style={{
          width: "100%",
          height: "100%",
          zIndex:"10"
        }}
      >
        <Environment preset="dawn" />
        <TitleModel mouse={mouse} scale={scale} />
      </Canvas>
    </div>
  );
};

export default Title3D;
